window.Vue = require('vue');

//Statistics
Vue.component('statistic-index', require('./statistics/index.vue'));
Vue.component('statistic', require('./widgets/statistics/statistic.vue'));
Vue.component('statistic-filter', require('./widgets/statistics/statisticFilter.vue'));
Vue.component('statistic-chart', require('./widgets/statistics/statisticChart.vue'));
Vue.component('statistic-super-commissions-index', require('./statistics-super-commissions/index.vue'));
Vue.component('statistic-super-commissions', require('./widgets/statistics-super-commissions/statistic.vue'));
Vue.component('statistic-super-commissions-filter', require('./widgets/statistics-super-commissions/statisticFilter.vue'));
Vue.component('statistic-super-commissions-chart', require('./widgets/statistics-super-commissions/statisticChart.vue'));

//Orders
Vue.component('order-shipping', require('./orders/orderShipping.vue'));
Vue.component('order-product', require('./orders/orderProduct.vue'));
Vue.component('order-products', require('./orders/orderProducts.vue'));
Vue.component('order-summary', require('./orders/orderSummary.vue'));
Vue.component('order', require('./orders/order.vue'));
Vue.component('orders-table', require('./orders/ordersTable.vue'));
Vue.component('shipping-brt-pudo', require('./orders/shippingBrtPudo.vue'));

//Widgets
Vue.component('downline-orders', require('./widgets/downlineOrders.vue'));


//Widgets statistics boxes
Vue.component('revenue-personal', require('./widgets/statistics/boxes/revenuePersonal.vue'));
Vue.component('revenue-downline', require('./widgets/statistics/boxes/revenueDownline.vue'));
Vue.component('count-introduced-users', require('./widgets/statistics/boxes/countIntroducedUsers.vue'));
Vue.component('revenue-introduced-users', require('./widgets/statistics/boxes/revenueIntroducedUsers.vue'));

//Topbar
Vue.component('sync-items', require('./topbar/syncItems.vue'));



// WEBPACK FOOTER //
// ./resources/js/app/components/vue-declarator.js